// src/hooks/useRemovedJobChecklists.js
// chk7d-4c7e1a92 — CHECKLISTS SEAM 7d (web). Live list of a job's REMOVED checklists, for the
// "Removed checklists" section of JobChecklistsPanel. "Removed" means kept on record: the server
// soft-removes (removed: true + removedBy / removedAt / removedReason) and never deletes.
//
// Its own listener (a single-field equality filter, no new index) so the two screens that host the
// panel need no change. `enabled` = office roles only: nothing is read for anyone else. Staff-only:
// the checklists collection has no portal clause in firestore.rules — never use this in a portal view.

import { useEffect, useState } from 'react';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../firebase/config';

const useRemovedJobChecklists = ({ orgId, jobId, enabled = true }) => {
    const [removed, setRemoved] = useState([]);

    useEffect(() => {
        if (!enabled || !orgId || !jobId) {
            setRemoved([]);
            return undefined;
        }
        return onSnapshot(
            query(collection(db, `organizations/${orgId}/jobs/${jobId}/checklists`), where('removed', '==', true)),
            (snap) => setRemoved(snap.docs.map(d => ({ id: d.id, ...d.data() }))),
            (err) => {
                console.error('useRemovedJobChecklists: listener failed', err);
                setRemoved([]);
            },
        );
    }, [orgId, jobId, enabled]);

    return removed;
};

export default useRemovedJobChecklists;
